import React from 'react';

interface MainContentProps {
  children: React.ReactNode;
}

/**
 * Main content wrapper for all pages.
 * Rounded corners on the left side only. No extra wrapper.
 */
export const MainContent: React.FC<MainContentProps> = ({ children }) => {
  return (
    <main className="flex-1 min-h-0 min-w-0 overflow-x-hidden overflow-y-auto bg-transparent px-3 pb-4 pt-3 sm:px-4 sm:pb-5 sm:pt-4 md:px-5 md:py-5 lg:min-h-screen lg:rounded-l-[24px] lg:px-7 lg:py-7">
      <div className="dashboard-content-auto w-full min-w-0 max-w-full">{children}</div>
    </main>
  );
};
